// extracted by mini-css-extract-plugin
export default {"checkout_summary":"Cz","checkout_summary_wrapper":"Ez","summary_items":"Fz","line_items_wrapper":"Gz","separator":"Hz","order_summary":"Iz","line_item":"Jz","order__summary_item_title":"Kz","recurringdis":"Lz","note":"Mz","carbon_emission":"Nz","unlock_savings":"Oz","member_perk":"Pz","info":"Qz","no_items":"Rz","promo":"Sz","order_summary_mobile":"Tz","open_summary_mobile":"Uz","fixed_bottom_info":"Vz","open_info":"Wz","text":"Xz","open_summary":"Yz"};
    if(module.hot) {
      // 1714442369172
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  